export function parseBooleanEnv(value: string | undefined, defaultValue = false): boolean {
  if (!value) return defaultValue

  const lowerValue = value.toLowerCase().trim()
  return lowerValue === 'true' || lowerValue === '1' || lowerValue === 'yes'
}
